/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Preview_PriceInputs */

const en_directory_promotion_preview_price = /** @type {(inputs: Directory_Promotion_Preview_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview price`)
};

const zh_directory_promotion_preview_price = /** @type {(inputs: Directory_Promotion_Preview_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览价格`)
};

/**
* | output |
* | --- |
* | "Preview price" |
*
* @param {Directory_Promotion_Preview_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_preview_price = /** @type {((inputs?: Directory_Promotion_Preview_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Preview_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_preview_price(inputs)
	return zh_directory_promotion_preview_price(inputs)
});
export { directory_promotion_preview_price as "directory.promotion.preview_price" }